"use strict";

var _toConsumableArray = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _classCallCheck = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _web3Utils = require("web3-utils"); // Copyright 2019 The FairDataSociety Authors
// This file is part of the FairDataSociety library.
//
// The FairDataSociety library is free software: you can redistribute it and/or modify
// it under the terms of the GNU Lesser General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// The FairDataSociety library is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
// GNU Lesser General Public License for more details.
//
// You should have received a copy of the GNU Lesser General Public License
// along with the FairDataSociety library. If not, see <http://www.gnu.org/licenses/>.


var Trace = require('./FDS-Trace');

var FDSContract =
/*#__PURE__*/
function () {
  // later we dynamically create methods
  function FDSContract(config) {
    _classCallCheck(this, FDSContract);

    var account = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var abi = arguments.length > 2 ? arguments[2] : undefined;
    var bytecode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "0x";
    this.account = account;
    this.config = config;
    this.abi = abi;
    this.bytecode = bytecode;
    this.web3 = this.config.web3;
    this.gasPrice = (0, _web3Utils.toWei)(config.gasPrice.toString(), 'gwei');
    this.contractAddress = null;
  }

  _createClass(FDSContract, [{
    key: "at",
    value: function at(contractAddress) {
      var _this = this;

      this.contractAddress = contractAddress;
      this.web3Instance = new this.web3.eth.Contract(this.abi, this.contractAddress);

      for (var i = 0; i < this.abi.length; i++) {
        if (this.abi[i]['type'] === 'function' && this.abi[i]['stateMutability'] === 'view') {
          (function () {
            var name = _this.abi[i]['name'];

            _this[name] = function () {
              return this.call(name, Array.prototype.slice.call(arguments));
            };
          })();
        } else if (this.abi[i]['type'] === 'function' && (this.abi[i]['stateMutability'] === 'payable' || this.abi[i]['stateMutability'] === 'nonpayable')) {
          (function () {
            var name = _this.abi[i]['name'];

            _this[name] = function () {
              return this.send(name, Array.prototype.slice.call(arguments), true, 15000000);
            };
          })();
        }
      }

      return this;
    }
  }, {
    key: "deploy",
    value: function deploy() {
      var _this2 = this;

      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var gas = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15000000;
      Trace.time('deployTransaction//Contract');
      return new Promise(function (resolve, reject) {
        var contract = new _this2.web3.eth.Contract(_this2.abi);
        var deployData = {
          data: _this2.bytecode
        };

        if (args !== []) {
          deployData.arguments = args;
        }

        var dataTx = contract.deploy(deployData).encodeABI();
        var privateKey = _this2.account.privateKey;
        var tx = {
          from: _this2.account.address,
          data: dataTx,
          gas: gas,
          gasPrice: _this2.gasPrice,
          nonce: _this2.account.nonce
        };
        _this2.account.nonce += 1;
        return _this2.web3.eth.accounts.signTransaction(tx, privateKey).then(function (signed) {
          return _this2.web3.eth.sendSignedTransaction(signed.rawTransaction).once('confirmation', function (i, receipt) {
            Trace.timeEnd('deployTransaction//Contract');
            _this2.transactionReceipt = receipt;
            resolve(_this2.at(receipt.contractAddress));
          });
        });
      });
    }
  }, {
    key: "send",
    value: function send(method) {
      var _this3 = this;

      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var confirm = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var gas = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 15000000;
      Trace.time('sendTransaction//Contract');
      return new Promise(function (resolve, reject) {
        var _web3Instance$methods;

        if (_this3.contractAddress === null || _this3.contractAddress === '0x0') {
          throw new Error('you must use ".at" or ".deploy" first');
        }

        var web3Instance = new _this3.web3.eth.Contract(_this3.abi, _this3.contractAddress);

        var dataTx = (_web3Instance$methods = web3Instance.methods)[method].apply(_web3Instance$methods, _toConsumableArray(args)).encodeABI();

        var privateKey = _this3.account.privateKey;
        var tx = {
          from: _this3.account.address,
          to: _this3.contractAddress,
          data: dataTx,
          gas: gas,
          gasPrice: _this3.gasPrice,
          nonce: _this3.account.nonce
        };
        _this3.account.nonce += 1;
        return _this3.web3.eth.accounts.signTransaction(tx, privateKey).then(function (signed) {
          return _this3.web3.eth.sendSignedTransaction(signed.rawTransaction).once('transactionHash', function (hash) {
            if (confirm === false) {
              Trace.log('sendTransaction//Contract', method, confirm);
              Trace.timeEnd('sendTransaction//Contract');
              resolve(hash);
            }
          }).once('confirmation', function (i, hash) {
            if (confirm === true) {
              Trace.log('sendTransaction//Contract', method, confirm);
              Trace.timeEnd('sendTransaction//Contract');
              resolve(hash);
            }
          });
        });
      });
    }
  }, {
    key: "call",
    value: function call(method) {
      var _web3Instance$methods2;

      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var gas = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 15000000;
      Trace.time('call//Contract');

      if (this.contractAddress === null || this.contractAddress === '0x0') {
        throw new Error('you must use ".at" or ".deploy" first');
      }

      var web3Instance = new this.web3.eth.Contract(this.abi, this.contractAddress);
      var address = this.account === undefined ? '0x' : this.account.address;

      var response = (_web3Instance$methods2 = web3Instance.methods)[method].apply(_web3Instance$methods2, _toConsumableArray(args)).call({
        from: address
      });

      Trace.log('call//Contract', method);
      Trace.timeEnd('call//Contract');
      return response;
    }
  }, {
    key: "getPastEvents",
    value: function getPastEvents() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "allEvents";
      var options = arguments.length > 1 ? arguments[1] : undefined;
      return new this.web3.eth.Contract(this.abi, this.contractAddress).getPastEvents(event, options);
    }
  }]);

  return FDSContract;
}();

var _default = FDSContract;
exports.default = _default;
module.exports = exports.default;